<template>
  <div class="content">
    <app-loading :active="loading"></app-loading>
    <form action="#" @submit="submit">
      <div class="box">
        <h2>Raporty</h2>
        <div class="row">
          <app-select type="number" name="type" placeholder="Typ" v-model="type" required>
            <option value="warehouse" selected>Zestawienie dokumentów magazynowych</option>
            <option value="stocktaking">Spis inwentaryzacyjny</option>
          </app-select>
        </div>
        <div class="row row--2">
          <app-input v-model="from" type="date" name="from" placeholder="Okres od" required></app-input>
          <app-input v-model="to" type="date" name="to" placeholder="do" required></app-input>
        </div>
        <button class="btn btn--margined btn--gradient" type="submit">Pobierz</button>
      </div>
    </form>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import {api} from '@/api'
import Select from "@/components/Select";
import Input from "@/components/Input";

export default {
  name: 'Reports',
  data() {
    return {
      loading: false,
      type: 'warehouse',
      from: '',
      to: ''
    }
  },
  methods: {
    async submit(e) {
      e.preventDefault()
      this.loading = true

      const response = await api.post(
        `/report/${this.type}`,
        {from: this.from, to: this.to},
        {responseType: 'blob'}
      )

      // TODO: wyciągnąć pobieranie Bloba do funkcji w utilsach
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', 'Raport.xlsx')
      document.body.appendChild(link)
      link.click()

      this.loading = false
    },
    getFormData(data) {
      this.form = data
    }
  },
  components: {
    AppLoading: Loading,
    AppSelect: Select,
    AppInput: Input
  },
  metaInfo: {
    title: 'Raporty'
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 20px 50px;
}

.row {
  margin-top: 40px;

  &--2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
}
</style>
